import MuiListItemButton from '@mui/material/ListItemButton';
import { withStyles } from 'tss-react/mui';

const StyledMuiListItem = withStyles(MuiListItemButton, {
    root: {
        '&$selected': {
            backgroundColor: '#3E536E',
            color: 'white',
        },
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.06)',
            color: 'white',
        },
    },
});

export default StyledMuiListItem;
